module.exports = __webpack_public_path__ + "img/w_zss.61293128.png";